import _ from 'lodash';
import { AnyAction } from 'redux';
import { entityCollectionDefaultState, EntityCollectionState } from '../entities/types/EntityCollectionState';
import {
    FAILURE_ADYEN_BATCHES,
    FAILURE_ADYEN_BATCHES_BY_BATCH_NUMBER,
    FAILURE_CONFIRM_ADYEN_BATCH,
    REQUEST_ADYEN_BATCHES,
    REQUEST_ADYEN_BATCHES_BY_BATCH_NUMBER,
    REQUEST_CONFIRM_ADYEN_BATCH,
    SUCCESS_ADYEN_BATCHES,
    SUCCESS_ADYEN_BATCHES_BY_BATCH_NUMBER,
    SUCCESS_CONFIRM_ADYEN_BATCH,
} from './actions';

export function adyenReducerAdmin(
    state: EntityCollectionState<any> = entityCollectionDefaultState(),
    action: AnyAction
) {
    switch (action.type) {
        case REQUEST_ADYEN_BATCHES:
            return _.assign({}, state, { isFetching: true, error: undefined });
        case SUCCESS_ADYEN_BATCHES: {
            return _.assign({}, state, {
                isFetching: false,
                items: action.response.data,
                error: undefined,
            });
        }
        case FAILURE_ADYEN_BATCHES:
            return _.assign({}, state, { isFetching: false, items: undefined, error: action.error });

        default:
            return state;
    }
}

export function adyenPreviewReducerAdmin(
    state: EntityCollectionState<any> = entityCollectionDefaultState(),
    action: AnyAction
) {
    switch (action.type) {
        case REQUEST_ADYEN_BATCHES_BY_BATCH_NUMBER:
            return _.assign({}, state, { isFetching: true, error: undefined });
        case SUCCESS_ADYEN_BATCHES_BY_BATCH_NUMBER: {
            return _.assign({}, state, {
                isFetching: false,
                items: action.response.data,
                error: undefined,
            });
        }
        case FAILURE_ADYEN_BATCHES_BY_BATCH_NUMBER:
            return _.assign({}, state, { isFetching: false, items: undefined, error: action.error });
        default:
            return state;
    }
}

export function adyenConfirmReducerAdmin(
    state: EntityCollectionState<any> = entityCollectionDefaultState(),
    action: AnyAction
) {
    switch (action.type) {
        case REQUEST_CONFIRM_ADYEN_BATCH:
            return _.assign({}, state, { isFetching: true, error: undefined });
        case SUCCESS_CONFIRM_ADYEN_BATCH: {
            return _.assign({}, state, {
                isFetching: false,
                items: action.response.data,
                error: undefined,
            });
        }
        case FAILURE_CONFIRM_ADYEN_BATCH:
            return _.assign({}, state, { isFetching: false, items: undefined, error: action.error });
        default:
            return state;
    }
}
